import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Product } from '@spartacus/core';
import { DealerPrice } from 'src/app/model/dealer-price.model';

@Component({
  selector: 'app-promotional-text',
  templateUrl: './promotional-text.component.html',
  styleUrls: ['./promotional-text.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class PromotionalTextComponent implements OnInit {
  @Input() productCode: string;
  @Input() product: Product;
  @Input() dealerPriceData: DealerPrice;
  @Input() cartItem: any;
  @Input() appliedProductPromotions: any[];
  @Input() orderEntryNumber: any;
  @Input() promotionLocation: string;
  @Input() charactersLimit: string;
  @Input() hasMemoField: string;
  promotionalTexts: string[] = [];

  constructor() {}

  ngOnInit() {
    if (this.promotionLocation === 'CART' || this.promotionLocation === 'SAVEDCARTDETAILS') {
      this.showAppliedProductPromotions();
      if (!this.promotionalTexts.length) {
        this.showPotentialPromotions();
      }
    } else {
      this.showPotentialPromotions(0);
    }
  }

  showAppliedProductPromotions() {
    if (this.appliedProductPromotions) {
      this.appliedProductPromotions.forEach((appliedProductPromotion) => {
        if (this.promotionDescChecker(appliedProductPromotion)) {
          if (this.promotionLocation === 'SAVEDCARTDETAILS' || this.promotionLocation === 'CART') {
            appliedProductPromotion.consumedEntries.forEach((consumedEntry: { orderEntryNumber: any }) => {
              if (this.promotionDescChecker(appliedProductPromotion)) {
                if (consumedEntry.orderEntryNumber === this.orderEntryNumber) {
                  this.promotionalTexts.push(appliedProductPromotion.description);
                }
              }
            });
          }
        }
      });
    }
  }

  promotionDescChecker(appliedProductPromotion: any) {
    return !this.promotionalTexts.includes(appliedProductPromotion.promotion.description);
  }

  showPotentialPromotions(index: number = null) {
    if (this.product && this.product.potentialPromotions) {
      if (index === 0) {
        this.promotionalTexts.push(this.product.potentialPromotions[0].description);
      } else {
        this.product.potentialPromotions.forEach((potentialPromotion) => {
          this.promotionalTexts.push(potentialPromotion.description);
        });
      }
    }
  }
}
